<template>
    <div class="sidebar-detail-modal" :class="{ 'show': visible }">
        <div class="sidebar-mask" @click="$emit('close')"></div>
        <transition name="slide">
            <div v-if="visible" class="sidebar-detail-popup">
                <div class="sidebar-header">
                    <span>帖子详情</span>
                    <el-button type="text" icon="el-icon-close" @click="$emit('close')"></el-button>
                </div>
                <div class="sidebar-content">
                    <!-- 骨架屏 -->
                    <div v-if="!hasPostData" class="skeleton-content">
                        <div class="skeleton-row">
                            <div class="skeleton-label"></div>
                        </div>
                        <div class="skeleton-row">
                            <div class="skeleton-text-long"></div>
                        </div>
                        <div class="skeleton-row">
                            <div class="skeleton-label"></div>
                            <div class="skeleton-text w-200"></div>
                        </div>
                        <div class="skeleton-row">
                            <div class="skeleton-label"></div>
                            <div class="skeleton-text w-200"></div>
                        </div>
                        <div class="skeleton-row">
                            <div class="skeleton-label"></div>
                            <div class="skeleton-media">
                                <div class="skeleton-img"></div>
                                <div class="skeleton-img"></div>
                                <div class="skeleton-img"></div>
                                <div class="skeleton-img"></div>
                            </div>
                        </div>
                        <div class="skeleton-row">
                            <div class="skeleton-label"></div>
                            <div class="skeleton-media">
                                <div class="skeleton-img"></div>
                                <div class="skeleton-img"></div>
                                <div class="skeleton-img"></div>
                                <div class="skeleton-img"></div>
                            </div>
                        </div>
                    </div>

                    <!-- 实际内容 -->
                    <div v-else>
                        <div class="detail-row content-row">
                            <span class="content-label">内容：</span>
                            <div class="content-value">{{ post.textPreview }}</div>
                        </div>
                        <div class="detail-row">{{ post.text }}</div>
                        <div class="detail-row"><b>时间：</b>{{ formatTime(post.dateSent) }}</div>
                        <div class="detail-row"><b>是否浏览：</b>{{ post.isPurchased ? '已浏览' : '未浏览' }}</div>
                        <div class="detail-row"><b class="shrink0">图片：</b>
                            <div class="media-row">
                                <template v-for="(photo, idx) in (post.photos || [])">
                                    <imagePreview :key="photo.id" :src="photo.url" :previewSrcList="post.photos"
                                        :currentIndex="idx" :listFields="'url'" class="post-img" />
                                </template>
                            </div>
                        </div>
                        <div class="detail-row"><b class="shrink0">视频：</b>
                            <div class="media-row">
                                <template v-for="(video, idx) in (post.videos || [])">
                                    <videoPreview :key="video.id" :coverSrc="video.url" :previewSrcList="post.videos"
                                        :currentIndex="idx" :videoId="Number(video.id)" class="post-video" />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
import imagePreview from '@/components/imagePreview.vue'
import videoPreview from '@/components/videoPreview.vue'

export default {
    name: 'PostDetail',
    components: {
        imagePreview,
        videoPreview
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        post: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['close', 'preview-more'],
    computed: {
        hasPostData() {
            return this.post && Object.keys(this.post).length > 0 && this.post.id
        }
    },
    methods: {
        formatTime(date) {
            const d = new Date(date)
            return d.toLocaleString()
        },
        handlePreviewMore(list, index, field) {
            this.$emit('preview-more', { list, index, field })
        }
    }
}
</script>

<style lang="scss" scoped>
.sidebar-detail-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 3000;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    pointer-events: none;

    &.show {
        pointer-events: auto;
    }
}

.sidebar-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s ease;

    .show & {
        opacity: 1;
    }
}

.sidebar-detail-popup {
    position: relative;
    z-index: 2;
    width: 40vw;
    height: 100vh;
    background: #fff;
    box-shadow: -2px 0 16px rgba(0, 0, 0, 0.13);
    border-radius: 10px 0 0 10px;
    display: flex;
    flex-direction: column;
    padding: 0 28px 28px 28px;
    overflow-y: auto;
}

.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 22px;
    font-weight: 600;
    padding: 22px 0 16px 0;
    border-bottom: 2px solid #e5e6eb;
    letter-spacing: 1px;
}

.sidebar-content {
    padding: 18px 0 0 0;

    .detail-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 22px;
        font-size: 16px;
        line-height: 1.8;

        .label {
            font-weight: 600;
            color: #222;
            width: 70px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-right: 12px;
            box-sizing: border-box;
            white-space: nowrap;
        }

        .value {
            color: #444;
            word-break: break-all;
            flex: 1;
            min-width: 0;
        }

        &.watch-row {
            align-items: center;

            .label {
                width: 90px;
                margin-right: 8px;
            }

            .watch-tag {
                font-size: 14px;
                padding: 2px 12px;
                border-radius: 12px;
                font-weight: 500;
                background: #f0f9eb;
                color: #67c23a;
                border: 1px solid #b7eb8f;
                margin-left: 0;
            }

            .watch-tag.unwatched {
                background: #f4f4f5;
                color: #909399;
                border: 1px solid #e4e7ed;
            }
        }

        .media-row {
            display: flex;
            gap: 10px;
            margin-top: 6px;
            flex-wrap: wrap;

            .post-img,
            .post-video {
                width: 80px;
                height: 80px;
                border-radius: 8px;
                border: 1px solid #eee;
                object-fit: cover;
            }
        }
    }
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s cubic-bezier(.55, 0, .1, 1);
}

.slide-enter,
.slide-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

.media-row {
    display: flex;
    gap: 8px;
    margin-bottom: 6px;
}

.more-mask {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
}

.img-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
}

.mask-text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 2em;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.4);
}

.content-row {
    display: block;
    margin-bottom: 22px;

    .content-label {
        display: block;
        font-weight: 700;
        color: #222;
        font-size: 16px;
        margin-bottom: 8px;
        text-align: left;
    }

    .content-value {
        color: #555;
        font-size: 15px;
        line-height: 1.8;
        word-break: break-all;
        white-space: pre-line;
    }
}

/* 骨架屏样式 */
.skeleton-content {
    padding: 18px 0 0 0;
}

.skeleton-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 22px;
    font-size: 16px;
    line-height: 1.8;
}

.skeleton-label {
    width: 70px;
    height: 20px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 4px;
    margin-right: 12px;
    flex-shrink: 0;
}

.skeleton-text {
    flex: 1;
    height: 20px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 4px;
}

.skeleton-text-long {
    flex: 1;
    height: 100px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 4px;
}

.skeleton-media {
    display: flex;
    gap: 10px;
    margin-top: 6px;
    flex-wrap: wrap;
}

.skeleton-img {
    width: 80px;
    height: 80px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 8px;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}
</style>